<h1 class="title">{{ title }}</h1>
<div class="subtitle">{{ name }}</div>
